import type { TrakerData } from '@bz/tracker';

export enum Events {
  LOGOUT = 'logout',
  ACCOUNT_UNAVAILABLE = 'account_unavailable',
  PENDING_ROOT = 'pending_root',
  PENDING_LEVEL_TOP = 'pending_level_top',
  PENDING_LEVEL_SECTION = 'pending_level_section',
  PENDING_REGISTER = 'pending_register',
  PENDING_RESOLVE = 'pending_resolve',
  PENDING_DONE = 'pending_done',
  TRACKER = 'tracker',
}

export type PromiseResolve<T> = (value: T | PromiseLike<T>) => void;

export type EventBus = {
  [Events.LOGOUT]: undefined;
  [Events.ACCOUNT_UNAVAILABLE]: undefined;
  [Events.PENDING_ROOT]: undefined;
  [Events.PENDING_LEVEL_TOP]: undefined;
  [Events.PENDING_LEVEL_SECTION]: undefined;
  [Events.PENDING_REGISTER]: undefined;
  [Events.PENDING_RESOLVE]: undefined;
  [Events.PENDING_DONE]: undefined;
  [Events.TRACKER]: {
    data: TrakerData[];
    /** Event callback */
    resolve: PromiseResolve<unknown>;
  };
};
